import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  input,
  signal,
} from '@angular/core';
import { TableModule } from 'primeng/table';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from 'primeng/tabs';
import { ReactiveFormsModule } from '@angular/forms';
import { FamilyMembersTableComponent } from './components/family-members-table/family-members-table.component';
import { FormBeneficiarySettingsBeneficiaryPreferencesComponent } from './components/form-beneficiary-settings-beneficiary-preferences/form-beneficiary-settings-beneficiary-preferences.component';
import { UserSettingsBeneficiaryDataComponent } from './components/beneficiary-settings-beneficiary-data/user-settings-beneficiary-data.component';
import { Beneficjent } from '../../shared/models/beneficjent';
import { Router } from '@angular/router';

@Component({
  selector: 'app-beneficiary-settings',
  imports: [
    TableModule,
    TabPanel,
    Tab,
    TabList,
    Tabs,
    ReactiveFormsModule,
    FamilyMembersTableComponent,
    FormBeneficiarySettingsBeneficiaryPreferencesComponent,
    UserSettingsBeneficiaryDataComponent,
    TabPanels,
  ],
  templateUrl: './beneficiary-settings.component.html',
  styleUrl: './beneficiary-settings.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BeneficiarySettingsComponent {
  readonly #router = inject(Router);

  protected tabFromUrl = input<string | undefined>(undefined, { alias: 'tab' });
  protected activeTab = signal<string>('0');
  protected page = input<string>();
  protected beneficiary = input.required<Beneficjent>();

  constructor() {
    this.#initTabSync();
  }

  #initTabSync(): void {
    effect(() => {
      const urlTab = this.tabFromUrl();
      const stateTab = this.activeTab();

      const normalizedUrlTab = urlTab ?? '0';

      if (normalizedUrlTab !== stateTab) {
        this.activeTab.set(normalizedUrlTab);
        return;
      }

      if (stateTab === '0' && !urlTab) return;
      if (stateTab === urlTab) return;

      this.#router.navigate([], {
        queryParams: stateTab !== '0' ? { tab: stateTab } : {},
        queryParamsHandling: 'merge',
        replaceUrl: true,
      });
    });
  }
}
